import { isEmpty } from 'lodash-es';
import { mapState, mapActions, mapGetters } from 'vuex';
import price from '@phoenix/mixins/price';

export default {
  mixins: [price],

  data() {
    return {
      loadOnCreate: true,
    };
  },

  computed: {
    ...mapState('wishlist', ['isLoading', 'products', 'error', 'areProductsLoaded']),

    ...mapGetters('wishlist', ['hasProducts']),
  },

  watch: {
    error(newError) {
      if (!isEmpty(newError)) {
        window.Phoenix.toaster.notify({
          type: 'danger',
          text: newError,
        });
      }
    },
  },

  async created() {
    if (this.loadOnCreate && !this.areProductsLoaded) {
      await this.loadWishlistProducts();
    }
  },

  methods: {
    ...mapActions('wishlist', ['loadWishlistProducts', 'removeProduct']),

    async onRemoveProduct(reference) {
      const removeButton = this.$refs[`remove-reference-${reference}`][0];
      Toolkit.helpers.buttons.addLoadingState(removeButton);
      await this.removeProduct({ reference });
      Toolkit.helpers.buttons.removeLoadingState(removeButton);
    },
  },
};
